import { lazy, Suspense, useEffect, useState } from "react";
import HeroSection from "@/components/HeroSection";

// Only the hero is eager: it is the LCP element. Everything below the fold is
// lazy so hero hydration finishes before the rest of the landing page mounts.
const WhySellSection = lazy(() => import("@/components/WhySellSection"));
const SuccessStories = lazy(() => import("@/components/SuccessStories"));
const HowToSellSection = lazy(() => import("@/components/HowToSellSection"));

const BelowFoldSkeleton = () => (
  <div className="container mx-auto grid grid-cols-1 gap-6 px-5 py-12 md:grid-cols-3" aria-hidden="true">
    <div className="h-36 animate-pulse rounded-lg bg-muted" />
    <div className="h-36 animate-pulse rounded-lg bg-muted" />
    <div className="h-36 animate-pulse rounded-lg bg-muted" />
  </div>
);

const HomePage = () => {
  // Defer mounting below-fold sections until the browser is idle, so the hero
  // paint and hydration are never blocked by their work.
  const [showBelowFold, setShowBelowFold] = useState(false);

  useEffect(() => {
    const idle = (window as typeof window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    }).requestIdleCallback;
    if (idle) {
      const id = idle(() => setShowBelowFold(true), { timeout: 1200 });
      return () => (window as any).cancelIdleCallback?.(id);
    }
    const t = setTimeout(() => setShowBelowFold(true), 200);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <HeroSection />
      {showBelowFold ? (
        <Suspense fallback={<BelowFoldSkeleton />}>
          <WhySellSection />
          <SuccessStories />
          <HowToSellSection />
        </Suspense>
      ) : (
        <BelowFoldSkeleton />
      )}
    </>
  );
};

export default HomePage;
